import React from 'react';
import { normalizeStorageUrl } from '../config/apiBase';

const isUrl = (value) => typeof value === 'string' && value.length > 0 && !/^\d+$/.test(value);

const webpSrcSet = (webp, webpSm, webpCard) => {
  const parts = [];
  if (isUrl(webpCard)) parts.push(`${normalizeStorageUrl(webpCard)} 480w`);
  if (isUrl(webpSm)) parts.push(`${normalizeStorageUrl(webpSm)} 960w`);
  if (isUrl(webp)) parts.push(`${normalizeStorageUrl(webp)} 1600w`);
  return parts.join(', ');
};

const ResponsiveImage = ({
  src,
  webp,
  webpSm,
  webpCard,
  alt = '',
  className = '',
  sizes = '100vw',
  ...imgProps
}) => {
  if (!src) return null;
  const srcSet = webpSrcSet(webp, webpSm, webpCard);

  return (
    <picture style={{ display: 'contents' }}>
      {srcSet ? <source type="image/webp" srcSet={srcSet} sizes={sizes} /> : null}
      <img src={normalizeStorageUrl(src)} alt={alt} className={className} {...imgProps} />
    </picture>
  );
};

export default ResponsiveImage;
